import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {UserSearchBoxService} from "./user-search-box.service";

@Component({
  selector: 'pbc-user-search-box',
  templateUrl: './user-search-box.component.html'
})
export class UserSearchBoxComponent implements OnInit {

  searchForm : FormGroup;

  constructor(
    private router : Router,
    private userSearchBoxService : UserSearchBoxService,
  ) { }

  ngOnInit() {
    this.searchForm = new FormGroup({
      'searchString' : new FormControl('', Validators.required)
    });
  }

  searchOnSubmit() {
    let searchString = this.searchForm.controls['searchString'].value;
    this.router.navigate(['user-search-results', searchString]);
    this.userSearchBoxService.notifySearchStringChanged(searchString);
    this.searchForm.controls['searchString'].reset('');
  }

}
